import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = ["id"];
const _hoisted_2 = { class: "mb-0" };
const _hoisted_3 = { key: 0 };
const _hoisted_4 = { key: 1 };
const _hoisted_5 = { style: { "float": "right" } };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", {
        id: _ctx.id,
        class: _normalizeClass(_ctx.cls)
    }, [
        _createElementVNode("div", _hoisted_2, [
            (_ctx.level === 1)
                ? (_openBlock(), _createElementBlock("strong", _hoisted_3, _toDisplayString(_ctx.title), 1))
                : (_ctx.title !== '')
                    ? (_openBlock(), _createElementBlock("em", _hoisted_4, _toDisplayString(_ctx.title), 1))
                    : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_5, [
                _renderSlot(_ctx.$slots, "afterTitle")
            ])
        ]),
        _renderSlot(_ctx.$slots, "default")
    ], 10, _hoisted_1));
}
